import { apiSlice } from "@/shared/api/api-slice"

import { SpinRequest, SpinResponse, MemoGameResponse } from "@/shared/types"

/**
 * Game API endpoints
 */
export const gameApi = apiSlice.injectEndpoints({
  endpoints: builder => ({
    spin: builder.mutation<SpinResponse, SpinRequest>({
      query: request => ({
        url: "/api/v1/spin",
        method: "POST",
        body: request
      }),
      invalidatesTags: (_, error) => (error ? [] : ["Balance"])
    }),

    playMemo: builder.mutation<MemoGameResponse, number>({
      query: chatId => ({
        url: `/api/v1/memo/play`,
        method: "POST",
        body: { chat_id: chatId }
      }),
      invalidatesTags: (_, error) => (error ? [] : ["Balance"])
    })
  })
})

// Export hooks for use in components
export const { useSpinMutation, usePlayMemoMutation } = gameApi
